import React from 'react';
import { Form } from 'react-bootstrap';

const CategorySelect = ({ 
  name, 
  value, 
  onChange, 
  categories = [], 
  className = '',
  showAllOption = false,
  allOptionText = 'Todas',
  placeholder = 'Selecione uma categoria',
  required = false,
  ...props 
}) => {
  return (
    <Form.Select
      name={name}
      value={value}
      onChange={onChange}
      className={className}
      required={required}
      {...props}
    >
      {!required && (
        <option value="">
          {showAllOption ? allOptionText : placeholder}
        </option>
      )}
      {categories.map(category => (
        <option key={category.id} value={category.id}>
          [{category.id.toString().padStart(2, '0')}] {category.name}
        </option>
      ))}
    </Form.Select>
  );
};

export default CategorySelect; 